import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link } from 'react-router';
import {
  fetchFilesets,
  fetchFilesetPreviewById,
  fetchSingleDatasetById,
  fetchVersions,
} from '../../actions/data';
import { compare, storeWithExpiration } from '../../utils/common';
import FilesetPreview from './FilesetPreview';
import VersionSelector from '../shared/VersionSelector';

export class FilesetPreviewContainer extends React.Component {
  static propTypes = {
    currentFilesets: PropTypes.object.isRequired,
    dataSet: PropTypes.object,
    datasetId: PropTypes.string.isRequired,
    fetchFilesetsAction: PropTypes.func.isRequired,
    fetchFilesetPreviewByIdAction: PropTypes.func.isRequired,
    fetchSingleDatasetByIdAction: PropTypes.func.isRequired,
    fetchVersionsAction: PropTypes.func.isRequired,
    versionsSummary: PropTypes.object.isRequired,
  };

  static defaultProps = {
    dataSet: undefined,
  };

  constructor(props) {
    super(props);
    this.handleVersionSelectChange = this.handleVersionSelectChange.bind(this);
  }

  state = {
    versions: undefined,
    selectedVersion: undefined,
    accordionsOpen: [],
  };

  componentWillMount = () => {
    const {
      datasetId,
      fetchFilesetsAction,
      fetchSingleDatasetByIdAction,
      fetchVersionsAction,
    } = this.props;
    const token = storeWithExpiration.get('token');

    fetchSingleDatasetByIdAction(datasetId, token);
    fetchFilesetsAction(datasetId, token);
    fetchVersionsAction(datasetId, token);
  };

  componentWillReceiveProps = nextProps => {
    const { versionsSummary, datasetId } = nextProps;
    const versions = versionsSummary.get(datasetId);

    this.setState({
      versions,
    });
  };

  handleFilesetVersionChange = selectedVersion => {
    const { currentFilesets, datasetId, fetchFilesetPreviewByIdAction } = this.props;
    const token = storeWithExpiration.get('token');
    currentFilesets.valueSeq().map(fileset => {
      fetchFilesetPreviewByIdAction(token, parseInt(datasetId, 10), fileset.id, selectedVersion);
      return false;
    });
    this.setState({ accordionsOpen: [] });
  };

  handleVersionSelectChange = e => {
    this.setState({ selectedVersion: parseInt(e.target.value, 10) });
    this.handleFilesetVersionChange(parseInt(e.target.value, 10));
  };

  toggleAccordion = newAccordionId => {
    const { accordionsOpen } = this.state;
    const location = accordionsOpen.indexOf(newAccordionId);
    let updatedAccordionsOpen = [];

    // Only one accordion should be open at a time
    if (location < 0) updatedAccordionsOpen = [newAccordionId];

    this.setState({ accordionsOpen: updatedAccordionsOpen });
  };

  render() {
    const { versions } = this.state;
    const { currentFilesets, dataSet, datasetId } = this.props;
    if (versions) versions.sort(compare);

    return (
      <div className="modal-wrap">
        <div className="container-fluid container-home">
          <div className="header">
            <div className="header-body">
              <div className="row">
                <div className="col-md-12">
                  <h1 className="header-title">
                    {dataSet !== undefined && currentFilesets.size !== 0 ? (
                      <Link to={`/data/dataset/${datasetId}`}>
                        <i className="fa fa-angle-left" /> {dataSet.name}
                      </Link>
                    ) : null}
                  </h1>
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-12">
              <div className="card-border">
                <div className="card-header">
                  <div className="card-header-title">Data Preview</div>
                </div>
                <div className="card-block">
                  {dataSet !== undefined && currentFilesets.size !== 0 ? (
                    <p>
                      <VersionSelector
                        handleOnChange={this.handleVersionSelectChange}
                        selectedVersion={this.state.selectedVersion}
                        versions={versions}
                      />
                    </p>
                  ) : null}
                  <hr />
                  {dataSet !== undefined && currentFilesets.size !== 0 ? (
                    <div className="single-info-page">
                      {currentFilesets !== undefined ? (
                        <FilesetPreview
                          accordionsOpen={this.state.accordionsOpen}
                          datasetId={datasetId}
                          currentFilesets={currentFilesets}
                          toggleAccordion={this.toggleAccordion}
                          version={this.state.selectedVersion}
                        />
                      ) : null}
                    </div>
                  ) : null}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const { account, data } = state;
  const { params } = ownProps;
  const { datasetId } = params;
  const dataSet = data.get('dataset');
  const currentFilesets = data.get('currentFilesets');
  const versionsSummary = data.get('versionsSummary');

  return {
    account,
    currentFilesets,
    dataSet,
    datasetId,
    versionsSummary,
  };
};

export default connect(
  mapStateToProps,
  {
    fetchFilesetsAction: fetchFilesets,
    fetchFilesetPreviewByIdAction: fetchFilesetPreviewById,
    fetchSingleDatasetByIdAction: fetchSingleDatasetById,
    fetchVersionsAction: fetchVersions,
  }
)(FilesetPreviewContainer);
